import { render, staticRenderFns } from "./mdInQueryCaAction.vue?vue&type=template&id=63b768cf&scoped=true"
import script from "./mdInQueryCaAction.vue?vue&type=script&lang=js"
export * from "./mdInQueryCaAction.vue?vue&type=script&lang=js"
import style0 from "./mdInQueryCaAction.vue?vue&type=style&index=0&id=63b768cf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b768cf",
  null
  
)

export default component.exports